module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lengnau_AG-eb037ec59780269b03c689093a25f1b9.svg";